import { Routes, Route } from 'react-router-dom'
import { AuthStatusBar } from '@/components/AuthStatusBar'
import { HomePage } from '@/pages/HomePage'
import { QuetureViewPage } from '@/pages/QuetureViewPage'
import { LoginPage } from '@/pages/LoginPage'
import { NaverCallbackPage } from '@/pages/NaverCallbackPage'
import { NotFoundPage } from '@/pages/NotFoundPage'

export default function App() {
  return (
    <>
      <AuthStatusBar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/queture/:quetureId" element={<QuetureViewPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/naver" element={<NaverCallbackPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  )
}
